import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import Select, { SelectProps } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFSelectProps<
  T, Value, FormFields extends FieldValues,
> extends SelectProps<T, Value>, CommonReactHookFormProps<FormFields> {
  onSelectChange?: (data: Value) => void;
}

function RHFSelect<T, Value, FormFields extends FieldValues>(
  props: RHFSelectProps<T, Value, FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    options,
    onSelectChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleChange = (event: Value) => {
    onChange(event);
    if (onSelectChange) {
      onSelectChange(event);
    }
  };

  return (
    <Select
      label={label}
      error={error}
      value={field.value}
      onChange={handleChange}
      options={options}
      {...rest}
    />
  );
}

RHFSelect.defaultProps = {
  onSelectChange: () => { },
};

export default RHFSelect;
